(() => {
  const init = root => {
    if (root.dataset.pass2Ready) return;
    root.dataset.pass2Ready = 'true';
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const dock = root.querySelector('.dj-p2-dock');
    const brands = root.querySelector('.dj-p2-inline-brands');
    const dialog = root.querySelector('.dj-p2-dialog');
    const open = root.querySelector('.dj-p2-open');
    const collapse = root.querySelector('.dj-p2-collapse');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let collapsed = false;
    let wasOpening = true;
    let frame = 0;
    let timer = 0;
    let dead = false;
    const update = () => {
      frame = 0;
      const opening = Number(root.dataset.progress || 0) < .008;
      const fire = root.classList.contains('fire-playing');
      if (opening && !wasOpening) collapsed = false;
      wasOpening = opening;
      const expanded = opening && !collapsed && !fire && !matchMedia('(max-width: 900px)').matches;
      if (dock.dataset.expanded !== String(expanded)) {
        dock.dataset.expanded = String(expanded);
        brands.inert = !expanded;
        brands.setAttribute('aria-hidden', String(!expanded));
        collapse.setAttribute('aria-expanded', String(expanded));
      }
      root.classList.toggle('p2-discover', opening);
      
      const cards = root.querySelector('.dj-intro .dj-cards');
      if (cards && opening) {
        const transform = getComputedStyle(cards).transform;
        const revealOffset = transform === 'none' ? 0 : new DOMMatrixReadOnly(transform).m42;
        const top = cards.getBoundingClientRect().top - root.querySelector('.dj-stage').getBoundingClientRect().top - revealOffset;
        root.style.setProperty('--dj-p2-gear-top', `${top}px`);
      }
      if (!opening || fire || root.classList.contains('is-still') || reduced.matches) {
        clearTimeout(timer);
        if (!root.classList.contains('p2-settled')) root.classList.add('p2-settled');
      }
    };
    const schedule = () => { if (!dead && !frame) frame = requestAnimationFrame(update); };
    collapse.addEventListener('click', () => { collapsed = true; update(); open.focus(); }, options);
    open.addEventListener('click', () => {
      if (!dialog.open) dialog.showModal();
    }, options);
    root.querySelector('.dj-p2-close').addEventListener('click', () => dialog.close(), options);
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); }, options);
    dialog.addEventListener('close', () => { if (!root.classList.contains('fire-playing')) open.focus(); }, options);
    const observer = new MutationObserver(schedule);
    observer.observe(root, { attributes: true, attributeFilter: ['class', 'data-progress'] });
    const resize = new ResizeObserver(schedule);
    resize.observe(root.querySelector('.dj-stage'));
    resize.observe(root.querySelector('.dj-intro .dj-copy'));
    window.addEventListener('resize', schedule, options);
    reduced.addEventListener('change', schedule, options);
    document.fonts?.ready.then(schedule);
    root.classList.add('p2-ready');
    timer = setTimeout(() => root.classList.add('p2-settled'), 1000);
    update();
    const cleanup = () => { dead = true; if (dialog.open) dialog.close(); controller.abort(); observer.disconnect(); resize.disconnect(); clearTimeout(timer); cancelAnimationFrame(frame); delete root.dataset.pass2Ready; };
    root.addEventListener('delta:destroy', cleanup, { once: true, signal: controller.signal });
    document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) cleanup(); }, options);
  };
  const scan = () => document.querySelectorAll('delta-journey.dj-pass2').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();



/* Keep a keyboard-focused product completely visible in the mobile carousel. */
document.addEventListener('focusin', (event) => {
  if (!(event.target instanceof Element) || !window.matchMedia('(max-width: 900px)').matches) return;
  const product = event.target.closest('.dj.dj-final .dj-product');
  if (!product || !product.matches(':focus-visible')) return;
  requestAnimationFrame(() => {
    if (document.activeElement === product) {
      product.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'instant' });
    }
  });
});